import React, { useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import BarcodeScannerComponent from "react-qr-barcode-scanner";
import {
  Button,
  Dialog,
  DialogContent,
  DialogActions,
} from "@material-ui/core";

const QrCodeScanner = ({
  isOpen,
  onScan,
  onClose,
  partType,
}) => {
  const { t } = useTranslation();
  const [verifyIsOpen, setVerifyIsOpen] = useState(false);
  const [errorIsOpen, setErrorIsOpen] = useState(false);
  const [scanResult, setScanResult] = useState("");
  const [scanError, setScanError] = useState("");

  const handleScan = (data) => {
    if (data && data !== "") {
      const items = data.text.split(",");
      setScanResult(items.length === 3 ? items[2] : items[0]);
      setVerifyIsOpen(true);
    }
  };

  const handleError = (err) => {
    console.error(err);
    setScanError(err);
    setErrorIsOpen(true);
  };

  const closeVerify = () => {
    setVerifyIsOpen(false);
    onScan(scanResult);
  };

  const cancelVerify = () => {
    setVerifyIsOpen(false);
  };

  const cancelError = () => {
    setErrorIsOpen(false);
  };

  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogContent style={{ maxWidth: "300px" }}>
        <BarcodeScannerComponent
          onError={handleError}
          onUpdate={(err, result) => {
            if (result) handleScan(result);
          }}
        />

        <Dialog open={verifyIsOpen} onClose={cancelVerify}>
          <DialogContent style={{ maxWidth: "200px" }}>
            {t(`Vehicles.PartTypes.${partType}`)}: {scanResult}
          </DialogContent>
        
          <DialogActions>
            <Button onClick={cancelVerify}>{t("Vehicles.ReplaceComponent.Cancel")}</Button>
            <Button onClick={closeVerify}>{t("Vehicles.ReplaceComponent.Confirm")}</Button>
          </DialogActions>
        </Dialog>

        <Dialog open={errorIsOpen} onClose={cancelError}>
          <DialogContent style={{ maxWidth: "200px" }}>
            <div>{scanError}</div>
          </DialogContent>
        
          <DialogActions>
            <Button onClick={cancelError}>{t("Vehicles.ReplaceComponent.Ok")}</Button>
          </DialogActions>
        </Dialog>
      </DialogContent>
        
      <DialogActions>
        <Button onClick={onClose}>{t("Vehicles.ReplaceComponent.Cancel")}</Button>
      </DialogActions>
    </Dialog>
  );
};

QrCodeScanner.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onScan: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  partType: PropTypes.string.isRequired,
};

export default QrCodeScanner;
